import { localization } from '@ocean/configs'
import { namespace } from 'modules/simulatorTrainings/common/localization'
import { AssessmentStatus, VendorType } from 'modules/simulatorTrainings/common/types'

const { i18n } = localization

const I18_PATH = `${namespace}:simulatorTraining`

const VENDOR_NAMES = {
  [VendorType.Wartsila]: 'Wärtsilä',
}

class SimulatorTrainingUtils {
  getVendorName(vendor: VendorType): string {
    return VENDOR_NAMES[vendor]
  }

  getAssessmentNames() {
    const ASSESSMENT_NAMES = {
      [AssessmentStatus.Passed]: i18n.t(`${I18_PATH}.assessStatus.passed`),
      [AssessmentStatus.Failed]: i18n.t(`${I18_PATH}.assessStatus.failed`),
    }
    return ASSESSMENT_NAMES
  }

  getAssessmentOptions() {
    const ASSESSMENT_NAMES = this.getAssessmentNames()
    const ASSESSMENT_OPTIONS = [
      { value: AssessmentStatus.Passed, label: ASSESSMENT_NAMES[AssessmentStatus.Passed] },
      { value: AssessmentStatus.Failed, label: ASSESSMENT_NAMES[AssessmentStatus.Failed] },
    ]
    return ASSESSMENT_OPTIONS
  }

  getAssessName(assess: AssessmentStatus | null = null) {
    const ASSESSMENT_NAMES = this.getAssessmentNames()
    return assess !== null && ASSESSMENT_NAMES[assess]
      ? ASSESSMENT_NAMES[assess]
      : i18n.t(`${I18_PATH}.assessStatus.notRated`)
  }
}

export default new SimulatorTrainingUtils()
